<div class="si-ticket-header-priority-container">
  <div class="si-ticket-header-priority-color" [ngStyle]="{ 'background-color': colorCode }"></div>
  <div class="si-ticket-header-priority-text">{{ description }}</div>
</div>
